"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));

var _styles = require("@mui/styles");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FotoConEliminar({
  foto,
  cargando,
  onDelete,
  album,
  esProduccion,
  mobile
}) {
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  const imagen = foto ? foto.url : '';
  const hideHeight = !mobile && esProduccion && album;
  return (0, _react2.jsx)("div", {
    css: classes.root
  }, (0, _react2.jsx)("div", {
    css: album ? classes.containerImageAlbum : classes.containerImage
  }, !cargando ? (0, _react2.jsx)("div", {
    css: classes.containerDeleteButton
  }, (0, _react2.jsx)(_material.Button, {
    css: classes.deleteButton,
    onClick: () => onDelete(foto)
  }, (0, _react2.jsx)(_Delete.default, null))) : null, (0, _react2.jsx)("img", {
    style: hideHeight ? {
      width: '100%'
    } : {
      width: '100%',
      height: '100%'
    },
    css: cargando ? classes.blur : null,
    src: imagen
  }), cargando ? (0, _react2.jsx)("div", {
    css: classes.progressContainer
  }, (0, _react2.jsx)(_material.CircularProgress, null)) : null));
}

var _default = FotoConEliminar;
exports.default = _default;